import { render, staticRenderFns } from "./Lambda.vue?vue&type=template&id=8564369a&scoped=true"
import script from "./Lambda.vue?vue&type=script&lang=ts"
export * from "./Lambda.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8564369a",
  null
  
)

export default component.exports